





















































































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { MedicalSpecification } from "@/components/medicalTransmissionEdit/types";
import { SelectItemString } from "@/types";
import EditDayChangePicker from "@/components/common/EditDayChangePicker.vue";
import NumberInput from "@/components/common/NumberInput.vue";

@Component({
  components: { EditDayChangePicker, NumberInput }
})
export default class BasicInfo4 extends Vue {
  @Prop() tab!: MedicalSpecification;
  @Prop() payer_type_codes!: SelectItemString[]; //負担者種別コード
  @Prop() confirmation_category_codes!: SelectItemString[]; //確認区分コード

  //NumberInputなので以下処理必須
  get ReductionCertificateNo() {
    return this.tab.reduction_certificate_no;
  }
  set ReductionCertificateNo(newValue: string) {
    if (newValue == null) {
      this.tab.reduction_certificate_no = "";
    } else {
      this.tab.reduction_certificate_no = String(newValue);
    }
  }
}
